import { motion } from 'framer-motion';
import * as React from 'react';

import Text from '../../../../text/Text.jsx';

export type SurveyContainerProps = {
  headline: React.ReactNode;
  prevButton?: React.ReactNode;
  nextButton?: React.ReactNode;
  children?: React.ReactNode;
};

const SurveyContainer = ({
  headline,
  prevButton,
  nextButton,
  children
}: SurveyContainerProps) => (
  <motion.div className="survey-container" layout>
    <motion.div className="survey-container__prev-button" layout="position">
      {prevButton}
    </motion.div>

    <motion.div className="survey-container__inner" layout="position">
      <Text
        className="survey-container__headline"
        variant="headline-3"
        tag="h2"
      >
        {headline}
      </Text>

      <div className="survey-container__content">{children}</div>
    </motion.div>

    {nextButton && (
      <motion.div className="survey-container__next-button" layout="position">
        {nextButton}
      </motion.div>
    )}
  </motion.div>
);

export default SurveyContainer;
